<template>
  <div>
    <location />
    <div class="page">
      <swiper
        :options="{
          slidesPerView: 'auto',
          freeMode: true,
          //initialSlide: tab - 1,
        }"
        class="swiper-tab-main"
      >
        <swiper-slide :class="{ active: tab === 1 }"
          ><div @click="tab_change(1)">
            {{ $t("button.tournament.tournament_condition") }}
          </div></swiper-slide
        >
        <swiper-slide :class="{ active: tab === 2 }"
          ><div @click="tab_change(2)">
            {{ $t("button.tournament.tournament_rank") }}
          </div></swiper-slide
        >
      </swiper>
      <ul class="nav nav-pills wrap-1200" id="pills-tab" role="tablist">
        <li class="nav-item col-6" role="presentation">
          <button
            class="w-100 nav-link"
            id="pills-1-tab"
            type="button"
            role="tab"
            aria-controls="pills-1"
            aria-selected="true"
            :class="{ active: tab == 1 }"
            @click="tab_change(1)"
          >
            {{ $t("button.tournament.tournament_condition") }}
          </button>
        </li>
        <li class="nav-item col-6" role="presentation">
          <button
            class="w-100 nav-link"
            id="pills-2-tab"
            type="button"
            role="tab"
            aria-controls="pills-2"
            aria-selected="false"
            :class="{ active: tab === 2 }"
            @click="tab_change(2)"
          >
            {{ $t("button.tournament.tournament_rank") }}
          </button>
        </li>
      </ul>

      <div class="tab-content wrap-1200" id="pills-tabContent">
        <Router-View ref="childRef" />
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="
              $router
                .push({
                  name: 'TournamentSchedule',
                  query: {
                    searchtype: $route.query.searchtype,
                    searchname: $route.query.searchname,
                  },
                })
                .catch(() => {})
            "
          >
            {{ $t("button.common.list") }}
          </b-button>
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('text.common.participation')"
            @click="callChildMethod"
            v-if="this.gametype_fk==1 && this.participationtype_fk==2"
          >
            {{ $t("text.common.participation") }}
          </b-button>
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('text.common.participation')"
            @click="callChildMethod"
            v-if="!this.participationtype_fk"
          >
            {{ $t("text.common.participation") }}
          </b-button>
          <!-- <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('text.common.participation') + $t('title.common.tournament')"
            @click="callChildMethod_no"
            v-else
          >
            {{ $t("text.common.offline") }} {{ $t("title.common.tournament") }}
          </b-button>           -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "TournamentScheduleView",
  components: {
    location,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tour_pk: this.$route.params.id,
      gametype_fk: this.$route.params.gametype_fk,   
      participationtype_fk: this.$route.params.participationtype_fk,    
      
      /*swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true
      }*/
    };
  },
  computed: {
    tab: function () {
      return this.$route.name === "Ranking" ? 2 : 1;
    },
  },
  methods: {
    callChildMethod() {
      this.$refs.childRef.participation(this.tour_pk);
    },
    callChildMethod_no() {
      this.$refs.childRef.participation_no(this.tour_pk);
    },    
    // testfunc() {
    //   // this.$refs.childRef.test(this.test);
    //   // console.log(this.test);
    //   alert(this.gametype_fk);
    // },
    tab_change(tab_no) {
      //this.tab = tab_no
      if (tab_no === 1)
        this.$router
          .push({
            name: "Condition",
            query: {
              searchname: this.$route.query.searchname,
              searchtype: this.$route.query.searchtype,
            },
          })
          .catch(() => {});
      else if (tab_no === 2)
        this.$router
          .push({
            name: "Ranking",
            query: {
              searchname: this.$route.query.searchname,
              searchtype: this.$route.query.searchtype,
            },
          })
          .catch(() => {});
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>
